import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { EmptyObject } from 'types';
import { updateDfiAnnualReport } from '../methods';
import { UpdateDfiReportRequest } from '../types';

export const useUpdateDfiAnnualReport = (): UseMutationResult<
  EmptyObject,
  unknown,
  UpdateDfiReportRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(updateDfiAnnualReport, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getDfiAnnualReport] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getDfiAnnualReports] });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getDfiAnnualReport] });
    },
  });
};
